import React, { useState } from "react";
import clsx from "clsx";
import {
	Container,
	Row,
	Col,
	Button,
	ButtonToolbar,
	ButtonGroup,
} from "reactstrap";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import { Link } from "react-router-dom";
import Image from "../../../components/Image";
export default function OutdoorPresenter() {
	return (
		<TabPane tabId={"outdoor-presenter"} style={{ width: "100%" }}>
			<Row style={{ padding: 16 }}>
				<Col xs="12" sm={{ size: 12 }}>
					<h4>Outdoor Presenter</h4>
				</Col>
				<Col xs="12" sm={{ size: 12 }}>
					<p>Coming Soon...</p>
				</Col>
			</Row>
		</TabPane>
	);
}
